module.exports = __webpack_public_path__ + "img/musubell_logo_color_yoko.5c3ed2e2.png";